import './MobileModalForm.scss';

import {CloseOutlined} from '@ant-design/icons';
import {Form} from 'antd';
import cn from 'classnames';
import React, {useEffect, useId} from 'react';

import FormItem from '../FormItem/FormItem';

const MobileModalForm = ({
    form,
    formName,
    className,
    title,
    closeLabel,
    formFields = [],
    children,
    initialValues,
    onFinish,
    onCancel,
    submitButton,
    cancelButton,
    submitDisabled = false,
    requireDeps,
    handleRadioChange,
    handleSelect,
    handleChange,
    handleDatePick,
}) => {
    const titleId = useId();
    const watchedValues = Form.useWatch([], form);
    const values = {...initialValues, ...watchedValues};

    useEffect(() => {
        const dialog = document.getElementById(titleId)?.closest('[role="dialog"]');

        dialog?.setAttribute('aria-labelledby', titleId);

        return () => {
            if (dialog?.getAttribute('aria-labelledby') === titleId) dialog.removeAttribute('aria-labelledby');
        };
    }, [titleId]);

    return (
        <Form
            form={form}
            name={formName}
            className={cn('mobile-modal-form', className)}
            layout='vertical'
            initialValues={initialValues}
            onFinish={onFinish}
            scrollToFirstError={{block: 'center'}}
            noValidate
            onValuesChange={(changedValues) => {
                const [name] = Object.keys(changedValues);

                handleChange?.(changedValues[name], name);
            }}
        >
            <div className='mobile-modal-form-header'>
                <h2 id={titleId}>{title}</h2>
                <button
                    type='button'
                    className='mobile-modal-close ant-modal-close'
                    aria-label={closeLabel}
                    onClick={onCancel}
                >
                    <CloseOutlined aria-hidden='true' />
                </button>
            </div>
            <div className='mobile-modal-form-body'>
                <div className='mobile-modal-section'>
                    <div className='mobile-modal-fields'>
                        {formFields.map(({key, name, hidden, row, ...field}) => (
                            <div
                                key={name || key}
                                className='mobile-modal-field'
                                hidden={
                                    typeof hidden === 'function'
                                        ? requireDeps
                                            ? hidden(values[requireDeps], values[field.itemDeps])
                                            : hidden(values)
                                        : hidden
                                }
                            >
                                <FormItem
                                    {...field}
                                    name={name}
                                    form={form}
                                    requireDeps={requireDeps}
                                    preserve
                                    className={row ? 'w-full' : undefined}
                                    inlineFeedback
                                    handleRadioChange={handleRadioChange}
                                    handleSelect={handleSelect}
                                    handleChange={handleChange}
                                    handleDatePick={handleDatePick}
                                />
                            </div>
                        ))}
                    </div>
                    {children}
                </div>
            </div>
            <div className='mobile-modal-form-actions'>
                <button type='button' className='mobile-modal-cancel' onClick={onCancel}>
                    {cancelButton}
                </button>
                <button type='submit' className='mobile-modal-submit' disabled={submitDisabled}>
                    {submitButton}
                </button>
            </div>
        </Form>
    );
};

export default MobileModalForm;
